module.exports = __webpack_public_path__ + "static/media/map-mask.753b0f36.svg";